import withErrorCheck from "../CheckError";
import server from "../Server";
import type { IGameView } from "@grassrootly/api/entities";

export interface GetSeasonMatchesPayload {
  seasonId: number;
}

// Fetch all matches for a season from organization_games_view
export const GetSeasonMatches = async ({ seasonId }: GetSeasonMatchesPayload): Promise<IGameView[]> => {
  const response = await server
    .from("organization_games_view")
    .select("*")
    .eq("season_id", seasonId)
    .eq("game_type", "ORGANIZATION_MATCH")
    .order("game_datetime", { ascending: true });

  const data = withErrorCheck<IGameView[]>(response as any) || [];
  return data;
};
